// extracted by mini-css-extract-plugin
export var smallSpinner = "_q9-0";